export const stripTags = (tags: Array<string>, html: string): string =>
	html.replace(new RegExp(`</?(${tags.join('|')}).*?/?>`, 'g'), '');

export const capitalizeFirstLetter = (string: string): string => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};
